export const enum SocketEvents {
  JOINED = "joined",
  CONNECT = "connect",
  DISCONNECT = "disconnect",

  SEND_MESSAGE = "send_message",
  RECEIVE_MESSAGE = "receive_message",

  ERROR = "error",
  CONNECTION_LOST = "connection_lost",

  OPERATOR_SURVEY = "operator_survey",
  AI_SURVEY = "ai_survey",
  FEEDBACK_RESPONSE_AI = "feedback_response_ai",
  FEEDBACK_RESPONSE_OPERATOR = "feedback_response_operator",

  FETCH_HISTORY = "fetch_history_request",
  FETCH_HISTORY_RESPONSE = "fetch_history_response",

  OPERATOR_STATUS_REQUEST = "operator_status_request",

  SHARE_CONTACTS = "share_contact",
  SHARE_CONTACT_RESPONSE = "share_contact_response",

  NEW_SESSION = "new_session",

  IDENTIFICATION_REQUEST = "identification_request",
  IDENTIFICATION_DISMISSED = "identification_dismissed",
  IDENTIFICATION_CANCELLED = "identification_cancelled",
}

export enum AttachmentType {
  VIDEO = 'video',
}

export type TAttachment = {
  type: AttachmentType;
  url: string;
  name?: string;
};

export type TBaseMessagePayload = {
  userId: string;
  messageSource: string;
};

export type TMessageResponse = TBaseMessagePayload & {
  message: string;
  messageId: string;
  role: 'Operator' | 'AI' | 'System' | 'User';
  attachments?: TAttachment[];
};

export type TShareContactResponse = TMessageResponse & {
  dismissed?: boolean;
};

export type TSendMessagePayload = TBaseMessagePayload & {
  phone?: string;
  is_new: boolean;
  isMobile: "True" | "False";
  message: string;
  messageId: string;
  isAi?: boolean;
  sessionId?: string;
};

export type TChatHistory = {
  chatId: string;
  history: Array<{
    role: string;
    messageId: string;
    message: string;
    date: string;
    sessionId: string;
    attachments?: TAttachment[];
  }>;
  sessionId: string;
  userId: string;
};

export type TConnectionLostResponse = TBaseMessagePayload;

export type TErrorResponse = TBaseMessagePayload & {
  origin: string;
  message: string;
};

export type TShareContacts = {
  userId: string;
  phone: string;
  birthdate: string;
  requestId?: number;
};

export type TIdentificationRequestPrefill = {
  phone: string;
  birthdate: string;
};

export type TIdentificationRequest = {
  userId: string;
  requestId: number;
  reason: "contact" | "birthdate";
  prefill: TIdentificationRequestPrefill;
};

export type TIdentificationDismissed = {
  userId: string;
  requestId?: number;
  reason: "closed" | "saved_empty";
};

export type TIdentificationCancelled = {
  userId: string;
  requestId: number;
  reason: string;
  chatState: "active" | "operator" | "closed";
};

export type TAISurveyResponse = TBaseMessagePayload & {
  sessionId: string;
  session_id: string;
  message: string;
  operatorMode: boolean;
};

export type TAISurveyFeedback = TBaseMessagePayload & {
  session_id: string;
  rate: number;
};

export type TOperatorSurveyResponse = TBaseMessagePayload & {
  message: string;
  session_id: string;
  sessionId: string;
  buttons?: string[];
  operatorMode: boolean;
};

export type TGetOperatorStatusResponse = {
  operatorMode: boolean;
};

export type TSurveyFeedback = TBaseMessagePayload & {
  sessionId: string;
  rate: number | string;
  isAi: boolean;
};

export type TServerToClientEvents = {
  [SocketEvents.RECEIVE_MESSAGE]: (data: TMessageResponse) => void;
  [SocketEvents.FETCH_HISTORY_RESPONSE]: (data: TChatHistory) => void;
  [SocketEvents.OPERATOR_SURVEY]: (data: TOperatorSurveyResponse) => void;
  [SocketEvents.AI_SURVEY]: (data: TAISurveyResponse) => void;
  [SocketEvents.DISCONNECT]: () => void;
  [SocketEvents.ERROR]: (data: TErrorResponse) => void;
  [SocketEvents.CONNECTION_LOST]: (data: TConnectionLostResponse) => void;
  [SocketEvents.NEW_SESSION]: () => void;
  [SocketEvents.SHARE_CONTACT_RESPONSE]: (data: TShareContactResponse) => void;
  [SocketEvents.IDENTIFICATION_REQUEST]: (data: TIdentificationRequest) => void;
  [SocketEvents.IDENTIFICATION_CANCELLED]: (data: TIdentificationCancelled) => void;
};

export type TClientToServerEvents = {
  [SocketEvents.JOINED]: (data: TBaseMessagePayload) => void;
  [SocketEvents.SEND_MESSAGE]: (data: TSendMessagePayload) => void;
  [SocketEvents.FETCH_HISTORY]: (data: TBaseMessagePayload) => void;
  [SocketEvents.OPERATOR_STATUS_REQUEST]: (
    data: TGetOperatorStatusResponse
  ) => void;
  [SocketEvents.FEEDBACK_RESPONSE_AI]: (data: TSurveyFeedback) => void;
  [SocketEvents.FEEDBACK_RESPONSE_OPERATOR]: (data: TSurveyFeedback) => void;
  [SocketEvents.SHARE_CONTACTS]: (data: TShareContacts) => void;
  [SocketEvents.IDENTIFICATION_DISMISSED]: (data: TIdentificationDismissed) => void;
};
